import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_ROUTE_STATUS_FINISH_RESET = 'PUT_ROUTE_STATUS_FINISH_RESET';
export const PUT_ROUTE_STATUS_FINISH_LOADING = 'PUT_ROUTE_STATUS_FINISH_LOADING';
export const PUT_ROUTE_STATUS_FINISH_SUCCESS = 'PUT_ROUTE_STATUS_FINISH_SUCCESS';
export const PUT_ROUTE_STATUS_FINISH_REJECT = 'PUT_ROUTE_STATUS_FINISH_REJECT';

//* ACTIONS ------------------------------------------------
export const putRouteStatusFinishReset = () => ({ type: PUT_ROUTE_STATUS_FINISH_RESET });
export const putRouteStatusFinishLoading = () => ({ type: PUT_ROUTE_STATUS_FINISH_LOADING });
export const putRouteStatusFinishSuccess = (payload) => ({ type: PUT_ROUTE_STATUS_FINISH_SUCCESS, payload });
export const putRouteStatusFinishReject = (payload) => ({ type: PUT_ROUTE_STATUS_FINISH_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putRouteStatusFinishRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/Route/web/UpdateRouteChangestatusFinishRoute`, options);
};

